import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { AuthProvider } from './auth/AuthProvider'
import { followDeskTheme } from './lib/theme'
import './styles.css'

// Two routes do not justify a router dependency. Hosting already rewrites
// everything to index.html, so a path check is enough to pick the screen.
const settingsFirst = window.location.pathname.startsWith('/settings')

// Whether to hold the content to a readable column. The question is not which
// screen is open but where the panel is: inside Desk it gets a sidebar a few
// hundred pixels wide, and in a browser tab it would otherwise stretch to
// whatever the monitor is. The path told us neither, so opening the app at /
// and walking to settings left the rows running the full width of the screen.
const wide = window.parent === window

if (wide) document.body.classList.add('wide')

// Before the first render and outside every screen: an agent sitting in
// settings when they switch Desk to night should see the panel follow.
followDeskTheme()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <App wide={settingsFirst} />
    </AuthProvider>
  </StrictMode>,
)
